import classnames from 'classnames'
import * as React from 'react'
import * as Reakit from 'reakit/Popover'

import { useZIndex } from '../dialog'

interface PopoverButtonProps extends Reakit.PopoverDisclosureHTMLProps {
  state: Reakit.PopoverStateReturn
  as?: React.ElementType
}
/**
 * The trigger button component which handles ref & focus return, etc.
 */
export const PopoverTrigger = React.forwardRef(
  ({ state, ...props }: PopoverButtonProps, ref: React.ForwardedRef<HTMLButtonElement>) => {
    const zIndex = useZIndex()

    return (
      <Reakit.PopoverDisclosure
        ref={ref}
        {...props}
        as={props.as ?? 'button'}
        {...state}
        className={classnames(props.className, {
          [zIndex]: state.visible,
        })}
      >
        {props.children}
      </Reakit.PopoverDisclosure>
    )
  }
)
